import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import useRefreshToken from '../../../Hooks/useRefreshToken';
import { useUserState } from '../../../Hooks/useUserState';
import useLocalStorage from '../../../Hooks/useLocalStorage';

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);

    const refresh = useRefreshToken();
    const navigate = useNavigate();

    const { setAuth, ...state } = useUserState();
    const [persist] = useLocalStorage('persist', false);

    useEffect(() => {
        let isMounted = true;

        const verifySession = async () => {
            try {
                // no access token -> try refresh
                if (!state?.accessToken) {
                    await refresh();
                    return;
                }

                // validate current token
                const payload = JSON.parse(atob(state.accessToken.split('.')[1]));

                const expired = payload.exp * 1000 < Date.now();

                if (expired) {
                    // access token expired
                    await refresh();
                }
            } catch (error) {
                console.log('Session expired');

                setAuth(null);

                navigate('/login', { replace: true });
            } finally {
                if (isMounted) {
                    setIsLoading(false);
                }
            }
        };

        if (persist) {
            verifySession();
        } else {
            setIsLoading(false);
        }

        return () => {
            isMounted = false;
        };
    }, []);

    if (!persist) {
        return <Outlet />;
    }

    if (isLoading) {
        return <p>Loading...</p>;
    }

    return <Outlet />;
};

export default PersistLogin;
